import React from 'react';
import './Footer.css';

import {
  FaLinkedinIn,
  FaGithub,
  FaInstagram,
  FaFacebookF,
  FaXTwitter,
} from 'react-icons/fa6';

const logo = '/rapidus_logo.png';

const footerLinks = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Careers', href: '/careers' },
  { label: 'Blog', href: '/blog' },
];

const socials = [
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/company/rapidusai',
    icon: <FaLinkedinIn />,
  },
  {
    label: 'GitHub',
    href: 'https://github.com',
    icon: <FaGithub />,
  },
  {
    label: 'Instagram',
    href: 'https://instagram.com',
    icon: <FaInstagram />,
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com',
    icon: <FaFacebookF />,
  },
  {
    label: 'X',
    href: 'https://x.com',
    icon: <FaXTwitter />,
  },
];

const handleNavClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string
) => {
  if (href.startsWith('/')) return;

  e.preventDefault();

  const id = href.replace('#', '');
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
  });
};

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer__left">
      <img
        src={logo}
        alt="Rapidus AI"
        className="footer__logo-img"
      />

      <p className="footer__tagline">
        Enterprise AI that ships to production — not just PowerPoint.
      </p>

      <p className="footer__contact-info">
        📞 +91 9866224780
        <br />
        📧 info@rapidus-ai.com
        <br />
        🌐 www.rapidus-ai.com
      </p>

      <p className="footer__copy">
        © {new Date().getFullYear()} Rapidus AI Private Limited
        <br />
        <span className="footer__reg">
          CIN: U62013TS2025PTC203468
        </span>
        <br />
        <span className="footer__reg">
          GSTIN: 36AAPCR0032D1ZP
        </span>
      </p>
    </div>

    <div className="footer__center">
      <p className="footer__col-label">Quick Links</p>

      {['#services', '#about', '#projects', '#team', '#contact'].map(
        (href) => (
          <a
            key={href}
            href={href}
            className="footer__link"
            onClick={(e) => handleNavClick(e, href)}
          >
            {href.replace('#', '')}
          </a>
        )
      )}
    </div>

    <div className="footer__right">
      <p className="footer__col-label">Legal & More</p>

      {footerLinks.map((link) => (
        <a
          key={link.label}
          href={link.href}
          className="footer__link"
        >
          {link.label}
        </a>
      ))}

      <div className="footer__socials">
        {socials.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            className="footer__social-link"
          >
            {social.icon}
          </a>
        ))}
      </div>
    </div>
  </footer>
);

export default Footer;